<template>
    <div class="confirm-email">
        <div class="align-self-center text-center">
            <h1>Recover password</h1>
            <p v-if="accountUnfinished" class="text-subheading">
                Your account already exist. Please follow the instructions from the email you received to set your password.
                If the email doesn’t arrive after a few minutes, try checking your spam folder.
                If you still can’t find it, please try again, or <a href="https://www.sellersshield.com/contact">contact support</a>.
            </p>
            <p v-else class="text-subheading">
                If the email doesn’t arrive after a few minutes, try checking your spam folder.
                If you still can’t find it, please try again, or <a href="https://www.sellersshield.com/contact">contact support</a>.
            </p>
            <a href="#" @click="$router.push({ name: 'auth' })">Back to login</a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmailSent',
        props: {
            accountUnfinished: {
                required: false,
                default: false
            }
        },
    data: () => ({}),
}
</script>